module.exports = __webpack_public_path__ + "img/roi.2cd78822.png";